import React, {
  // useMemo,
  useState,
} from 'react'
// import { useRouteMatch } from 'react-router'
import {
  useHistory,
  //  useLocation
} from 'react-router-dom'
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { useTranslation } from 'react-i18next'
// import { SITE_MATE_DATA } from '../utils/constant'

// const showTabRoutes = [
//   {
//     path: '/',
//   },
//   {
//     path: '/doctor',
//   },
//   {
//     path: '/faq',
//   },
//   {
//     path: '/product-cancer-screening',
//   },
//   {
//     path: '/product-prophecy',
//   },
//   {
//     path: '/product-health-check-package',
//   },
//   { path: '/clinic/:id' },
//   { path: '/signin' },
//   { path: '/signup' },
//   { path: '/profile/order' },
//   { path: '/profile/account' },
//   { path: '/ProductList' },
//   { path: '/clinic' },
//   { path: '/promotion' },
// ]

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      height: '100%',
      [theme.breakpoints.down('xs')]: {
        height: 'auto',
        margin: theme.spacing(0, -2),
      },
    },
    scroller: {
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
    textColorInherit: {
      opacity: 1,
    },
    tabRoot: {
      fontSize: theme.spacing(2),
      fontWeight: theme.typography.fontWeightBold,
      minWidth: 'auto',
      textTransform: 'capitalize',
      color: 'primary.main',
      padding: ({ language }) => theme.spacing(0, language === 'en' ? 1 : 3),
      [theme.breakpoints.down('md')]: {
        maxWidth: theme.spacing(20),
        fontSize: theme.spacing(2),
        padding: ({ language }) => theme.spacing(0, language === 'en' ? 1 : 1.5),
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: ({ language }) =>
          language === 'en' ? theme.typography.caption.fontSize : theme.spacing(2),
      },
      [theme.breakpoints.down('xs')]: {
        padding: 0,
        flexBasis: 'auto',
        whiteSpace: 'nowrap',
      },
    },
    selected: {
      color: theme.palette.primary.main,
    },
    indicator: {
      display: 'none',
      backgroundColor: theme.palette.primary.main,
    },
  }),
)

const HomeTabs = () => {
  const history = useHistory()
  // const { pathname } = useLocation()
  const { t, i18n } = useTranslation()

  const tabRoutes = [
    {
      label: t('glossary.homepage'),
      path: '/',
    },
    {
      label: t('glossary.product_list'),
      path: '/productList',
    },
    // {
    //   label: 'glossary.know_screening',
    //   path: `${process.env.REACT_APP_WEBSITE_URL}/${i18n.language}${SITE_MATE_DATA.EARLY_CANCER_DETECTION}`,
    // },
    {
      label: t('glossary. promotion_discount'),
      path: '/promotion',
    },
    {
      label: 'glossary.faq',
      path: '/faq',
    },
  ]
  const [active, setActive] = useState(true)
  const classes = useStyles({ language: i18n.language, active: active })
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('xs'))

  // const showTab = useMemo(() => {
  //   const isTabRoutes = showTabRoutes.find((item) =>
  //     useRouteMatch(pathname, { path: item.path, exact: true }),
  //   )
  //   return isTabRoutes
  // }, [pathname])

  const handleChange = (e, newValue) => {
    history.push(`/${i18n.language}${tabRoutes[newValue]?.path}`)
  }

  return (
    <Tabs
      classes={{
        scroller: classes.scroller,
        indicator: classes.indicator,
      }}
      className={classes.root}
      // value={curTab}
      onChange={handleChange}
      variant={matches ? 'fullWidth' : 'scrollable'}
      scrollButtons="off"
    >
      {tabRoutes.map((tabRoute, i) => {
        return (
          <Tab
            classes={{
              root: classes.tabRoot,
              selected: classes.selected,
              textColorInherit: classes.textColorInherit,
            }}
            onClick={() => {
              setActive(false)
            }}
            key={i}
            label={t(tabRoute.label)}
          />
        )
      })}
    </Tabs>
  )
}

export default HomeTabs
